import { useCollapsePanel } from "hooks/useCollapsePanel";
import { v4 as uuidv4 } from "uuid";
import { stringFormattingToCurrency } from "js/formatting";
import { useTranslation } from "react-i18next";

export default function DepositsAndwithdrawals({ deposits, withdrawals }) {
  const { t } = useTranslation();
  const uuid = uuidv4();
  useCollapsePanel(uuid);

  return (
    <div className="ui-card mb-4 md:mb-6">
      <div className="md:flex md:flex-row md:items-start">
        <div className="px-4 pt-3 md:flex-grow xl:px-6 xl:pt-6">
          <h2 className="mb-0">
            <div className="flex flex-row md:hidden">
              <button
                id={uuid}
                className="flex items-center group md:hidden"
                aria-controls={`${uuid}-panel`}
                aria-expanded="true"
                aria-label="Expand or collapse Deposits &amp; Withdrawals details"
              >
                <span className="inline-block p-1 rounded-full mr-2 text-ui-blue group-hover:text-white group-hover:bg-ui-blue">
                  <svg
                    className="ui-icon ui-plus w-4 h-4"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-plus"></use>
                  </svg>
                  <svg
                    className="ui-icon ui-minus w-4 h-4"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-minus"></use>
                  </svg>
                </span>
                <span className="text-base font-body font-bold md:ui-no-badge-icon-inline">
                  {t(
                    "CustomerPolicyDetails-annuity-deposits-withdrawals-card-fields-title"
                  )}
                </span>
              </button>
            </div>
            <span className="text-xl font-body font-bold hidden md:block">
              {t(
                "CustomerPolicyDetails-annuity-deposits-withdrawals-card-fields-title"
              )}
            </span>
          </h2>
        </div>
        <hr className="mb-0 mt-3 md:hidden" />
      </div>
      <hr className="hidden md:block" />
      <div
        id={`${uuid}-panel`}
        className="px-4 pb-4 overflow-hidden h-20 md:h-auto xl:px-6 xl:pb-6"
      >
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 xl:gap-6">
          <div>
            <div className="text-xs text-theme-text-tertiary">
              {t(
                "CustomerPolicyDetails-annuity-deposits-withdrawals-card-fields-gross-deposits"
              )}
            </div>
            {deposits?.length > 0 &&
              deposits?.map((deposit, idx) => {
                return (
                  <div
                    className="text-sm text-theme-text-secondary font-semibold"
                    key={`deposit - ${idx}`}
                  >
                    {stringFormattingToCurrency(deposit?.grossDepSinceIncep)}
                  </div>
                );
              })}
          </div>
          <div>
            <div className="text-xs text-theme-text-tertiary">
              {t(
                "CustomerPolicyDetails-annuity-deposits-withdrawals-card-fields-gross-withdrawals"
              )}
            </div>
            {withdrawals?.length > 0 &&
              withdrawals?.map((withdrawal, idx) => {
                return (
                  <div
                    className="text-sm text-theme-text-secondary font-semibold"
                    key={`withdrawal - ${idx}`}
                  >
                    {stringFormattingToCurrency(withdrawal?.grossWitSinceIncep)}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
